import { useLocation } from "react-router"

import { capture } from "~/client/posthog.client"
import { ForestBackdrop } from "~/components/landing/ForestBackdrops"
import { ButtonLink } from "~/components/ui/button"

// The conversion card every post carries right after its intro (before the
// first <H2>): a forest card with the topo texture, one line of pitch and a
// single "Get access" button to /get-started, the same destination as the
// header's "Book a meeting" and the footer band. One action on purpose, so
// the card reads as a decision, not a menu.
//
// Copy defaults to a pitch that fits any post; pass `title`/`body` when a
// post has a sharper angle (e.g. the data behind a research post). Clicks
// are tracked as `explore_data_clicked` with `location: "blog_inline"` and
// the post path, alongside the hero/footer clicks.
export function BlogCta({
  title = "Put aggregated location intelligence to work",
  body = "Foot traffic, trade areas and visitor profiles for places and areas, in the Insights dashboard or through the API.",
  label = "Get access",
}: {
  title?: string
  body?: string
  label?: string
}) {
  const { pathname } = useLocation()

  return (
    <aside
      aria-label="Get access to Pine59"
      className="relative mt-10 overflow-hidden rounded-xl bg-forest px-6 py-7 sm:px-8 sm:py-8"
    >
      <ForestBackdrop lazy />
      <div className="relative sm:flex sm:items-end sm:justify-between sm:gap-8">
        <div className="max-w-md">
          <p className="font-sans text-[22px] font-semibold leading-snug tracking-tight text-hay">
            {title}
          </p>
          <p className="mt-2 text-[16px] leading-relaxed text-cream/75">
            {body}
          </p>
        </div>
        <div className="mt-5 shrink-0 sm:mt-0">
          <ButtonLink
            surface="dark"
            href="/get-started"
            onClick={() =>
              capture("explore_data_clicked", {
                location: "blog_inline",
                post: pathname,
              })
            }
          >
            {label}
          </ButtonLink>
        </div>
      </div>
    </aside>
  )
}
